import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle, faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { TPageTitleProps } from "../../Types";
import ET3Div from "../et3-div";
import Et3Text from "../et3-text";
import {
  PAGE_SUBTITLE_FONT_SIZE,
  PAGE_TITLE_ACCENT_GAP,
  PAGE_TITLE_ACCENT_HEIGHT,
  PAGE_TITLE_ACCENT_RADIUS,
  PAGE_TITLE_ACCENT_WIDTH,
  PAGE_TITLE_MARGIN_BOTTOM,
  PAGE_TITLE_PADDING_BOTTOM,
  PAGE_TITLE_PADDING_TOP,
  PAGE_TITLE_ACTION_HOVER,
  PAGE_TITLE_ACTION_ICON_SIZE,
  PAGE_TITLE_ACTION_RADIUS,
  PAGE_TITLE_ACTION_SIZE,
  PAGE_TITLE_ACTIONS_GAP,
  PAGE_TITLE_ACTIONS_WIDTH,
  PAGE_TITLE_BORDER,
  PAGE_TITLE_FONT_SIZE,
  PAGE_TITLE_GAP,
  PAGE_TITLE_HEIGHT,
  PAGE_TITLE_TRANSITION,
  PAGE_TITLE_WIDTH
} from "./page-title-constants";

const PageTitleAction = withLiteObserverAndTheme<{
  icon: IconProp;
  onPress: () => void;
}>((props) => {
  const { icon, onPress, theme } = props;
  const { colors, unitX, unitY } = theme;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onPress()}
      style={{
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: 0,
        cursor: "pointer",
        flexShrink: 0,
        backgroundColor: isHovered
          ? PAGE_TITLE_ACTION_HOVER
          : colors.all.transparent,
        width: PAGE_TITLE_ACTION_SIZE * unitX,
        height: PAGE_TITLE_ACTION_SIZE * unitY,
        borderRadius: PAGE_TITLE_ACTION_RADIUS * unitX,
        transition: PAGE_TITLE_TRANSITION
      }}
    >
      <FontAwesomeIcon
        icon={icon}
        color={colors.all.bondiBlue}
        style={{
          width: PAGE_TITLE_ACTION_ICON_SIZE * unitX,
          height: PAGE_TITLE_ACTION_ICON_SIZE * unitY
        }}
      />
    </button>
  );
});

const Et3PageTitle = withLiteObserverAndTheme<TPageTitleProps>((props) => {
  const { title, subTitle, withRefresh, withHelper, onPress, theme } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={PAGE_TITLE_WIDTH}
      height={PAGE_TITLE_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="space-between"
      color={colors.all.transparent}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        height: "auto",
        borderBottom: PAGE_TITLE_BORDER,
        paddingTop: PAGE_TITLE_PADDING_TOP * unitY,
        paddingBottom: PAGE_TITLE_PADDING_BOTTOM * unitY,
        marginBottom: PAGE_TITLE_MARGIN_BOTTOM * unitY
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={PAGE_TITLE_WIDTH}
        height={PAGE_TITLE_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          flexGrow: 1,
          width: "auto",
          minWidth: 0,
          height: "auto",
          gap: PAGE_TITLE_GAP * unitX
        }}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={PAGE_TITLE_ACCENT_WIDTH}
          height={PAGE_TITLE_ACCENT_HEIGHT}
          fDirection="row"
          alignItems="center"
          justifyContent="center"
          color={colors.all.bondiBlue}
          style={{
            flexShrink: 0,
            marginRight: (PAGE_TITLE_ACCENT_GAP - PAGE_TITLE_GAP) * unitX,
            borderRadius: PAGE_TITLE_ACCENT_RADIUS * unitX
          }}
          onClick={() => {}}
        />
        <Et3Text
          text={title}
          fontFamily="BOLD"
          fontSize={PAGE_TITLE_FONT_SIZE}
          color={colors.all.maastrichtBlue}
          isSpan={false}
          style={{ margin: 0, textAlign: "left", whiteSpace: "nowrap" }}
        />
        <Et3Text
          text={subTitle}
          fontFamily="LIGHT"
          fontSize={PAGE_SUBTITLE_FONT_SIZE}
          color={colors.all.davysGrey}
          isSpan={false}
          style={{
            margin: 0,
            textAlign: "left",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={PAGE_TITLE_ACTIONS_WIDTH}
        height={PAGE_TITLE_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-end"
        color={colors.all.transparent}
        style={{
          width: "auto",
          minWidth: 0,
          flexShrink: 0,
          gap: PAGE_TITLE_ACTIONS_GAP * unitX
        }}
        onClick={() => {}}
      >
        {!withRefresh ? null : (
          <PageTitleAction icon={faSync} onPress={() => onPress()} />
        )}
        {!withHelper ? null : (
          <PageTitleAction icon={faQuestionCircle} onPress={() => onPress()} />
        )}
      </ET3Div>
    </ET3Div>
  );
});

export default Et3PageTitle;
